import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import { MultiSelect } from "primereact/multiselect"
import { Dropdown } from "primereact/dropdown"
import myStyles from "../../../../styles/kiosk/KioskAdmin.module.css"
import { Tooltip } from "primereact/tooltip"

const Clone = ({
  cloneOrganization,
  visible,
  setVisible,
  selectedOrganization,
  organizations,
  setSelectedOrganization,
  isLoading,
  targetOrganizations,
  setTargetOrganizations,
  setSelectedOptions,
  selectedOptions,
  getOptions,
}) => {
  const clean = () => {
    setSelectedOptions([])
    setTargetOrganizations([])
    // setSelectedOrganization([])
    setVisible(false)
  }

  const HelpText = ({ text }) => {
    return <small style={{ color: "gray", marginBottom: "10px" }}>{text}</small>
  }

  return (
    <Dialog visible={visible} showHeader={false} style={{ width: "40vw" }}>
      <div className={myStyles.modalHeader}>
        <div>
          <Tooltip target={".tt-kioskClone"} className="custom-tooltip" />
          <label>Clone customization</label>
          <i
            className={`pi pi-info-circle ${myStyles.infoIcon} tt-kioskClone`}
            data-pr-tooltip={
              "Clone the RecoveryLink Kiosk configuration from one Organization to another."
            }
            data-pr-position="bottom"
          ></i>
        </div>

        <Button
          icon="pi pi-times"
          className={myStyles.hideModalButton}
          onClick={() => {
            clean()
          }}
          disabled={isLoading}
        />
      </div>
      <div className={myStyles.modalFormContainer}>
        <hr className={myStyles.modalHeaderLine} />
        <div className={myStyles.cloneContainer}>
          <div className={myStyles.cloneSelectorContainer}>
            <label className={myStyles.labelSelector}>
              From enterprise organization
            </label>
            <HelpText
              text={"The source organization to clone configuration from"}
            />
            <Dropdown
              placeholder="Select organization"
              className={myStyles.cloneSelector}
              panelClassName={myStyles.dropdownSelector}
              value={selectedOrganization?.organizationId}
              options={organizations}
              optionLabel="name"
              optionValue="organizationId"
              onChange={(e) => {
                setSelectedOrganization(e.value)
              }}
              disabled={isLoading}
            />
          </div>
          <div className={myStyles.cloneSelectorContainer}>
            <label className={myStyles.labelSelector}>
              To target organization
            </label>
            <HelpText
              text={"The target organization(s) to clone configuration to"}
            />
            <MultiSelect
              placeholder="Select target organizations"
              className={`${myStyles.cloneSelector} ${"custom-chips"}`}
              value={targetOrganizations}
              optionLabel="name"
              optionValue="id"
              options={organizations.filter(
                (o) => o.id !== selectedOrganization?.id
              )}
              onChange={(e) => {
                setTargetOrganizations(e.target.value)
                if (e.value && e.value.length === 0) {
                  setSelectedOptions([])
                }
              }}
              disabled={isLoading || !selectedOrganization}
              display="chip"
            />
          </div>
          <div className={myStyles.cloneSelectorContainer}>
            <label className={myStyles.labelSelector}>Options</label>
            <HelpText
              text={
                "Select the configuration options to clone to the target organization(s)"
              }
            />
            <MultiSelect
              placeholder="Select sections to clone"
              className={`${myStyles.cloneSelector} ${"custom-chips"}`}
              value={selectedOptions}
              options={getOptions()}
              onChange={(e) => {
                setSelectedOptions(e.target.value)
              }}
              disabled={
                isLoading ||
                !targetOrganizations ||
                targetOrganizations?.length === 0
              }
              display="chip"
            />
          </div>
          <div className={myStyles.actionContainer}>
            <Button
              label="Clone customization"
              className={`${myStyles.button} ${myStyles.primaryButton}`}
              onClick={() => {
                cloneOrganization()
              }}
              disabled={isLoading}
              iconPos="left"
              icon={isLoading && "pi pi-spin pi-spinner"}
            />
          </div>
        </div>
      </div>
    </Dialog>
  )
}
export default Clone
